<section *ngIf="section?.card" class="card-collection container py-5 lg:py-8">
  <app-attendee-category-collection
    class="col-span-12"
    [title]="section.title"
    [categories]="section.card"
  >
  </app-attendee-category-collection>
</section>
